import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CORE_PROVIDERS } from './core';
import { HTTP_INTERCEPTOR_PROVIDERS } from './interceptors';
import { UtilService } from './utils';
import { PERMISSION_PIPES } from './permissions';
import { PIPES } from './pipes';
import { StyErrorMessagesService } from './errors';
import { NgxStyxMemberModule, NgxStyxColorModule, NgxStyxFenceModule } from './components';
import { NgxTethysModule } from 'ngx-tethys';
import { AppRootContext, AppRootApiService, getPortalTransmissionExtraProviders } from './bootstrap';
import { StyxHeadService } from './browser';
import { PortalApplicationData } from './bootstrap/portal-application-data';

const COMPONENT_MODULES = [NgxStyxMemberModule, NgxStyxColorModule, NgxStyxFenceModule];

let portalApplicationData: PortalApplicationData;

@NgModule({
    // prettier-ignore
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot(),
        NgxTethysModule,
        ...COMPONENT_MODULES
    ],
    declarations: [
        ...PERMISSION_PIPES, ...PIPES
    ],
    // providers: [
    //     AppRootContext,
    //     AppRootApiService,
    //     StyxHeadService,
    //     UtilService,
    //     ...CORE_PROVIDERS,
    //     ...HTTP_INTERCEPTOR_PROVIDERS,
    //     StyErrorMessagesService
    // ],
    entryComponents: [],
    exports: [
        TranslateModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        NgxTethysModule,
        ...PERMISSION_PIPES,
        ...PIPES,
        ...COMPONENT_MODULES
    ]
})
export class NgxStyxModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: NgxStyxModule,
            providers: [
                AppRootContext,
                AppRootApiService,
                StyxHeadService,
                UtilService,
                ...CORE_PROVIDERS,
                ...HTTP_INTERCEPTOR_PROVIDERS,
                StyErrorMessagesService
            ]
        };
    }

    static forFeature(): ModuleWithProviders {
        const extraProviders = getPortalTransmissionExtraProviders();
        return {
            ngModule: NgxStyxModule,
            providers: [
                ...extraProviders,
                StyxHeadService,
                UtilService,
                ...CORE_PROVIDERS,
                ...HTTP_INTERCEPTOR_PROVIDERS,
                StyErrorMessagesService
            ]
        };
    }
}
